<template>
  <div>
    <div @click="handleClick" class="partner">
      <figure v-if="partner.Cultures && partner.Cultures[$store.state.language]">
        <img
          :src="$store.state.imgBase + partner.Image"
          :alt="partner.Cultures[$store.state.language].Name"
          :title="partner.Cultures[$store.state.language].Name"
        />
      </figure>
      <p>{{ text }}</p>
    </div>
    <lightbox
      :show="showLightbox"
      @onclose="showLightbox = false"
      :item="item"
    ></lightbox>
  </div>
</template>

<script>
// import { faChevronRight } from '@fortawesome/pro-solid-svg-icons'
import lightbox from '@/components/Lightbox.vue'

export default {
  name: 'starPartner',
  props: {
    id: {
      type: Number,
      default: -1
    },
    text: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      showLightbox: false,
      item: {},
      icons: {
      }
    }
  },
  components: {
    lightbox
  },
  computed: {
    partner () {
      var self = this
      var tmp = {}
      self.$store.state.partners.forEach((partner) => {
        if (partner.ID === this.id) {
          tmp = partner
        }
      })
      return tmp
    }
  },
  methods: {
    handleClick: function () {
      var self = this
      if (self.partner.Cultures) {
        self.item = {
          Title: self.partner.Cultures[self.$store.state.language].Name,
          Text: self.partner.Cultures[self.$store.state.language].Text,
          Image: self.$store.state.imgBase + self.partner.Image,
          Link: self.partner.Link
        }
        self.showLightbox = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.partner{
  figure{
    padding: 0 40px;
  }
  &:hover{
    cursor: pointer;
  }
}
</style>
